import React from 'react'
import { connect } from 'react-redux'
import { reduxForm, getFormValues, Field, SubmissionError } from 'redux-form'
import { Button } from 'semantic-ui-react'
import { Dialog, DialogTitle, DialogContent, DialogActions } from '@material-ui/core'
import FieldInput, { InputType as type } from 'components/SemanticForm'
import { NewBankGuaranteeContainer } from './styled'
import { validations, validateCase as vCase } from 'core/validate'
import { getBankOwners } from 'ducks/bankGuarantee'
import { isNullOrEmpty } from 'core/utilities'

const NewBankGuaranteeModal = (props) => {
  const { valueForm, handleSubmit, onSubmitData, closeModal, newBgData, 
    clearNewBgData, listNewBG, bankOwners, change, newBgIndex } = props
  const isNew = newBgData ? false : true

  React.useEffect(() => {
    if (!bankOwners.data.length && !bankOwners.loading) {
      props.getBankOwners()
    }
  }, [])

  const submitNewBG = () => {
    var bgNumberDuplicate = false
    if (isNew) {
      if (listNewBG.find(x => x.bankGuaranteeNumber === valueForm.bankGuaranteeNumber)) {
        if (!isNullOrEmpty(valueForm.bankGuaranteeNumber)) {
          bgNumberDuplicate = true
        }
      }
    } else {
      if (newBgData.bankGuaranteeNumber !== valueForm.bankGuaranteeNumber) {
        if (listNewBG.find(x => x.bankGuaranteeNumber === valueForm.bankGuaranteeNumber)) {
          if (!isNullOrEmpty(valueForm.bankGuaranteeNumber)) {
            bgNumberDuplicate = true
          }
        }
      }
    }

    if (!bgNumberDuplicate) {
      onSubmitData(valueForm, isNew, newBgData, newBgIndex)
      if (!isNew) clearNewBgData()
      closeModal()
    } else {
      throw new SubmissionError({ bankGuaranteeNumber: 'Bank Guarantee Number is Duplicate!' })
    }
  }

  return (
    <Dialog open={true} maxWidth='sm' fullWidth style={{ zIndex: 10 }}>
      <DialogTitle>New Bank Guarantee</DialogTitle>
      <DialogContent>
        <form>
          <NewBankGuaranteeContainer>
            <div className='rowFields'>
              <Field 
                name='bankGuaranteeNumber' 
                label='Bank Guarantee No.'  
                type={type.text} 
                component={FieldInput} />
              <Field 
                name='bankOwner' 
                label='Bank Owner' 
                loading={bankOwners.loading}
                options={bankOwners.data} 
                type={type.select}
                component={FieldInput} />
            </div>
            <div className='rowFields'>
              <Field 
                name='amount' 
                label='Amount (THB)' 
                require 
                allowNegative={false}
                type={type.number} 
                component={FieldInput} />
              <Field type={type.empty} component={FieldInput} />
            </div>
            <div className='rowFields'>
              <div className='rowFields'>
                <Field 
                  name='startDate' 
                  label='Start Date' 
                  type={type.date}
                  component={FieldInput} />
                <Field 
                  name='dueDate' 
                  label='Due Date'
                  type={type.date} 
                  component={FieldInput} 
                />
              </div>
              <Field type={type.empty} component={FieldInput} />
            </div>
            <div className='rowFields'>
              <div className='rowFields'>
                <Field type={type.empty} component={FieldInput} />
                <Field 
                  name='noExpire' 
                  label='No Expire Date'  
                  type={type.checkbox}
                  specialOnChange={(value) => {
                    if (value) {
                      change('dueDate', null)
                    }
                  }}
                  component={FieldInput} 
                />
              </div>
              <Field type={type.empty} component={FieldInput} />
            </div>
          </NewBankGuaranteeContainer>
        </form>
      </DialogContent>
      <DialogActions>
        <form onSubmit={handleSubmit(values => submitNewBG())}>
          <Button
            color='blue'
            content={isNew ? 'Add' : 'Save'}
            type='submit'
          />
          <Button
            color='red'
            content='Cancel'
            onClick={() => {
              clearNewBgData()
              closeModal()
            }}
          />
        </form>
      </DialogActions>
    </Dialog>
  )
}

const mapStateToProps = (state, props) => {
  const newBgData = props.newBgData || {}
  return ({
    valueForm: getFormValues('formNewBankGuarantee')(state) || {},
    initialValues: {
      id: newBgData.id || null,
      bankGuaranteeNumber: newBgData.bankGuaranteeNumber || '',
      amount: newBgData.amount || null,
      bankOwner: newBgData.bankOwner || '',
      startDate: newBgData.startDate || '',
      dueDate: newBgData.dueDate || '',
      noExpire: newBgData.noExpire !== null && newBgData.noExpire !== undefined ? newBgData.noExpire : false,
    },
    bankOwners: state.bg.bankOwners,
  })
}
  
const mapDispatchToProps = {
  getBankOwners
}

const validate = (values) => {
  let errors = {}
  validations(values, 'amount', [vCase.require], errors)

  if (values.startDate && values.dueDate && (values.startDate > values.dueDate)){
    errors.dueDate = 'Due date must be greater than Start date!'
  }

  return errors
}

const NewBankGuaranteeForm = reduxForm({
  form: 'formNewBankGuarantee',
  enableReinitialize: true,
  validate
})(NewBankGuaranteeModal)

export default connect(mapStateToProps, mapDispatchToProps)(NewBankGuaranteeForm)